import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { RouterLink, Router } from '@angular/router';
import { AdminNavbar }
from '../admin-navbar/admin-navbar';
@Component({
  selector: 'app-products-list',
  standalone: true,
  imports: [CommonModule, RouterLink,AdminNavbar],
  templateUrl: './products-list.html',
  styleUrls: ['./products-list.scss']
})
export class ProductsList implements OnInit {
  products: any[] = [];
  apiUrl = 'https://lazzaro-api1.onrender.com';
  loading = false;

  constructor(private http: HttpClient, private cdr: ChangeDetectorRef, private router: Router) {}

  ngOnInit() {
    this.loadProducts();
  }

  loadProducts() {
    this.loading = true;

    this.http.get<any[]>(`${this.apiUrl}/api/products`).subscribe({
      next: (res) => {
        this.products = res;
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.log('ERROR', err);
        this.loading = false;
        this.cdr.detectChanges();
      }
    });
  }

  editProduct(id: number) {
    this.router.navigate(['/admin/products/edit', id]);
  }

  deleteProduct(id: number) {
    if (!confirm('Delete product?')) return;

    const token = localStorage.getItem('token');

    this.http.delete(`${this.apiUrl}/api/products/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    }).subscribe(() => {
      this.loadProducts();
    });
  }
}